module.exports = __webpack_public_path__ + "img/landing-image2.2dd01340.svg";